import { useMemo } from 'react';

import EventBus from './EventBus';

const useEventBus = (space: string) => useMemo(() => new EventBus(space), [space]);

export default useEventBus;
